import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FadeIn } from "../../components/FadeIn";
import styles from "../../styles/Home.module.css";
import { getHomePageData } from "../../lib/firebase/firestore";
import { HomePageData } from "../../types";
import { FAQChatBot } from "../../components/FAQChatBot";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../lib/firebase/config";

// Default fallback
const defaultHomePageData: HomePageData = {
  hero: {
    title: "Crafting Spaces That Inspire",
    subtitle: "Explore my architectural projects — where form meets function.",
    backgroundImage: "https://picsum.photos/1920/1080",
  },
  featured: {
    title: "Modern Villa",
    description: "A minimalist design blending indoor and outdoor spaces.",
    image: "https://picsum.photos/800/600",
  },
};

export const Home = () => {
  const [data, setData] = useState<HomePageData | null>(defaultHomePageData);
  const [loading, setLoading] = useState(true);
  const [faqs, setFaqs] = useState<{ question: string; answer: string }[]>([]);
  console.log(faqs);
  // Fetch homepage data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const homeData = await getHomePageData();
        if (homeData && homeData.hero.backgroundImage) {
          setData(homeData);
        }
      } catch (error) {
        console.error("Error loading homepage data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Fetch FAQs in real-time
  useEffect(() => {
    const faqsCollection = collection(db, "faqs");
    const unsubscribe = onSnapshot(faqsCollection, (snapshot) => {
      const data = snapshot.docs.map(
        (doc) => doc.data() as { question: string; answer: string },
      );
      setFaqs(data);
    });

    return () => unsubscribe(); // cleanup on unmount
  }, []);

  if (loading || !data) return <div>Loading...</div>;

  const { hero } = data;

  return (
    <div className={styles.homeContainer}>
      {/* Hero Background */}
      <div
        className={styles.heroBackground}
        style={{
          backgroundImage: `url(${hero.backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "brightness(0.6)",
          transition: "background-image 0.5s ease",
        }}
      />

      {/* Overlay Text */}
      <FadeIn delay={0.3}>
        <div className={styles.contentWrapper}>
          <h1 className={styles.heroTitle}>{hero.title}</h1>
          <p className={styles.heroSubtitle}>{hero.subtitle}</p>
          <Link to="/projects" className={styles.ctaButton}>
            View Projects
          </Link>
        </div>
      </FadeIn>

      {/* FAQ ChatBot */}
      <FAQChatBot />
    </div>
  );
};
